import type { FC } from 'react'
// import Image from "next/image";
import MTDLogo from '~/assets/mtdLogo.svg'
// import BurgerIcon from './burgermenu.svg'
// import Link from 'react-router-dom'
// import { Navigation } from '../navigation';
import { useAuth } from '@lib/hooks'
// import { useRouter } from 'next/router';
// import { HeaderTestIds } from '@lib/testing';

interface HeaderProps {
  displayMenu?: boolean // decides whether to show the menu if the user is logged out
}

export const Header: FC<HeaderProps> = ({ displayMenu = false }) => {
  // const [active, setActive] = useState(false)
  const { user } = useAuth()
  // const router = useRouter()

  // function onLogoutClick(): void {
  //   setActive(false)
  //   logout()
  //   router.push(Navigation.home)
  // }

  const showMenu: boolean = user !== null || displayMenu
  // const userLoggedIn = user !== null

  return <>
    <header className={`flex flex-row h-16 p-4 font-normal text-fg-menu-item bg-fg-blue-320 shadow-lg md:px-20 items-center ${showMenu ? 'justify-between' : 'justify-center'}`}>
        <img src={MTDLogo} alt='MTD logo' className='h-5 my-2' />
    </header>
  </>
}

export default Header
